export const colors = {
  transactional: {
    base: '#dd0021',
    shaded: '#ac0111',
    dark: '#770012',
  },
  notTransactional: {
    base: '#0072ce',
    shaded: '#044cc3',
    dark: '#004175',
  },
  neutral: {
    transparent: 'transparent',
    gray: '#333333',
    grayCold: '#595959',
    grayMedium: '#8c8c8c',
    grayWarm: '#bfbfbf',
    grayLight: '#f5f5f5',
    white: '#ffffff',
    red: 'red',
    black: '#000000',
    green: '#008A00',
    silver: '#BBBBBB',
    grayBoulder: '#767676',
  },
} as const;
